import {DocumentExtractionImportFile} from '../types/DocumentExtractionImportFile';

export const EMPTY_FILE: DocumentExtractionImportFile = {
  contentType: null,
  fileUri: null,
  fileId: null,
  fileName: null,
  storageServiceFileId: null,
  zipIds: null,
  status: null,
  errorMessage: null,
};
